import { TwitterLogo } from '@phosphor-icons/react';

export default TwitterLogo;
